<template src="./PostManageTemplate.html"> </template>

<script>
import serviceHandler from "@/helpers/handlers/service";
import postsService from "@/services/gmbPosts";
import { postsManageMixin } from "@/helpers/mixins/posts-manage";
import { POSTS_CALL_TO_ACTION_TYPE } from "@/enums/posts.enum";
import moment from "moment";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { FORMAT } from "@/config/date-format";
import { SCHEDULE_TYPE } from "@/enums/schedule-type";

export default {
  name: "PostsEditPlannedPost",
  mixins: [postsManageMixin],
  data() {
    return {
      viewTitle: this.$t("message.common.postsEdit"),

      editMode: true,
      actionTypeItems: null,
      facilitiesQuantityBeforeEdit: null,
      isDestinationEdited: false,
      isPhotoEdited: false,
      isContentEdited: false,
      isScheduleEdited: false,
      publishAtLast: null,
      postDataBasic: null,
      selectionType: null
    };
  },
  computed: {
    callToActionItems() {
      return this.actionTypeItems.map((item, index) => {
        return {
          label: item,
          value: index + 1
        };
      });
    }
  },
  watch: {
    "form.publish_at": {
      handler(current, last) {
        if (!last) return;
        this.isScheduleEdited = current !== last;
      }
    },
    "form.image_url": {
      handler(current, last) {
        this.isPhotoEdited =
          (last && current !== last[0].sourceUrl) || (current && !last);
      }
    }
  },
  async created() {
    this.actionTypeItems = Object.keys(POSTS_CALL_TO_ACTION_TYPE);

    this.tabs = this.tabs.map(item => {
      return { ...item, disabled: true };
    });
    const {
      facilities,
      post_data,
      publish_at,
      type,
      add_to_store_locator,
      id
    } = await serviceHandler(
      postsService.getScheduledPost(this.$route.params.id)
    );
    this.postDataBasic = post_data;
    this.facilitiesQuantityBeforeEdit = this.getFacilitiesQuantity(
      facilities,
      this.getOldFacilitiesQuantity
    );
    this.publishAtLast = publish_at;
    this.type = type;

    if (post_data.event.schedule) {
      post_data.event.schedule = this.preparePostDateAndTime(
        post_data.event.schedule
      );
    }
    if (post_data.call_to_action) {
      post_data.call_to_action.type = this.callToActionItems.find(
        ({ label }) =>
          label.toLowerCase() ==
          post_data.call_to_action.actionType.toLowerCase()
      ).value;
      delete post_data.call_to_action.actionType;
    }
    this.form = {
      ...post_data,
      publish_at: moment(publish_at).format(),
      type,
      add_to_store_locator,
      id
    };

    this.image = post_data.image_url;
    this.selectedFacilitiesIds = facilities.facilities_ids;

    await this.getFacilitiesIds();

    if (facilities.cities) {
      this.searchTypeLocal = this.searchTypes.CITY;
    } else if (facilities.facilities_groups) {
      this.searchTypeLocal = this.searchTypes.FACILITIES_GROUPS;
    }
  },

  methods: {
    checkIfNestedValuesChanged(current, last) {
      if (!last || !current) return;
      const currentValues = Object.values(current);
      const lastValues = Object.values(last);
      return currentValues.some((item, index) => item !== lastValues[index]);
    },
    checkIfContentEdited(current, last) {
      return (
        current.text !== last.text ||
        current.alert_type !== last.alert_type ||
        this.checkIfNestedValuesChanged(current.offer, last.offer) ||
        this.checkIfNestedValuesChanged(
          current.call_to_action,
          last.call_to_action
        )
      );
    },
    getFacilitiesQuantity(facilities, callback) {
      const { cities, facilities_groups, facilities_ids } = facilities;
      const quantity = facilities_ids.length;
      this.selectionType = this.getEventSelectionType(facilities);
      return callback({
        cities,
        facilities_groups,
        quantity,
        selectionType: this.selectionType
      });
    },
    getOldFacilitiesQuantity({
      cities,
      facilities_groups,
      quantity,
      selectionType
    }) {
      return {
        old_locations_selection_type: selectionType,
        old_num_locations: this.getEventNumValue(
          !cities && !facilities_groups,
          quantity
        ),
        old_num_cities: this.getEventNumValue(cities, quantity),
        old_num_groups: this.getEventNumValue(facilities_groups, quantity)
      };
    },

    getNewFacilitiesQuantity({
      cities,
      facilities_groups,
      quantity,
      selectionType
    }) {
      return {
        new_locations_selection_type: selectionType,
        new_num_locations: this.getEventNumValue(
          !cities && !facilities_groups,
          quantity
        ),
        new_num_cities: this.getEventNumValue(cities, quantity),
        new_num_groups: this.getEventNumValue(facilities_groups, quantity)
      };
    },
    getEventSelectionType({ cities, facilities_groups, facilities_all }) {
      if (facilities_all) return "all";
      if (cities) return "cities";
      if (facilities_groups) return "groups";

      return "selected";
    },
    getEventNumValue(condition, quantity) {
      return condition ? quantity : 0;
    },
    async send() {
      this.$store.commit("company/SET_LOADING", true);
      const formData = this.getFromData();
      await postsService
        .editScheduledPost(this.form.id, formData)
        .then(({ data: { facilities, id: post_id, post_data } }) => {
          this.openAlertDialog(formData.publish_at);

          this.isContentEdited = this.checkIfContentEdited(
            post_data,
            this.postDataBasic
          );
          const eventParams = this.getEventParams(this.type, formData);
          const nextScheduleOtherDate =
            this.scheduleType === SCHEDULE_TYPE.OTHER_DATE
              ? formData.publish_at
              : null;

          this.$gtm.trackCustomEvent({
            event: GTM_EVENT_NAME.POSTS_MASS_EDIT,
            post_id,
            post_type: this.currentForm,
            photo: this.image
              ? {
                  height_px: this.image.height || null,
                  width_px: this.image.width || null,
                  size_kb:
                    Math.round((this.image.size / 1024) * 100) / 100 || null
                }
              : null,

            ...eventParams,
            ...this.facilitiesQuantityBeforeEdit,
            ...this.getFacilitiesQuantity(
              facilities,
              this.getNewFacilitiesQuantity
            ),
            schedule_edit: this.isScheduleEdited,
            contents_edit: this.isContentEdited,
            photo_edit: this.isPhotoEdited,
            destination_edit: this.isDestinationEdited,
            old_schedule: this.isScheduleEdited ? this.publishAtLast : null,
            new_schedule: this.isScheduleEdited ? this.scheduleType : null,
            new_schedule_other_date: this.isScheduleEdited
              ? nextScheduleOtherDate
              : null
          });
          this.resetForm();
          if (this.scheduleType === SCHEDULE_TYPE.NOW) {
            this.$router.push({ name: "posts-list-sent" });
          } else {
            this.$router.push({ name: "posts-list-planned" });
          }
        })
        .catch(this.requestErrorHandler);
      this.$store.commit("company/SET_LOADING", false);
    }
  }
};
</script>

<style lang="scss" scoped src="@/assets/scss/pages/postManage.scss"></style>
